import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const CreateDeviationTypeForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<TimeReportingFormTypes.CreateDeviationType>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
        comment: {
          label: TranslationKeys.Common.Comment,
          type: FormEnums.FormFieldType.TEXTAREA,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
    />
  );
};

export default forwardRef(CreateDeviationTypeForm);
